import type { ManagementLevel, OrgRole } from '@/services/org-admin';

// The roles an actor may grant to someone else (via invitation or reassignment):
// an owner may grant any role; an admin may only grant a member-level role.
// Mirrors the backend's authorize_level_grant rule in OrgAdminContext.
export function grantableRolesFor(currentUserRole: ManagementLevel | null, roles: OrgRole[]): OrgRole[] {
  if (currentUserRole === 'owner') return roles;
  if (currentUserRole === 'admin') return roles.filter((role) => role.management_level === 'member');
  return [];
}
